import { render, staticRenderFns } from "./AuthCenter.vue?vue&type=template&id=2a1236b8&scoped=true"
import script from "./AuthCenter.vue?vue&type=script&lang=js"
export * from "./AuthCenter.vue?vue&type=script&lang=js"
import style0 from "./AuthCenter.vue?vue&type=style&index=0&id=2a1236b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1236b8",
  null
  
)

export default component.exports